import React, { useEffect, useRef } from 'react';
import Chart from "chart.js/auto";
import { CategoryScale, LinearScale, BarController, BarElement, LineController, LineElement, PointElement, PieController, ArcElement} from 'chart.js';

Chart.register(CategoryScale, LinearScale, BarController, BarElement, LineController, LineElement, PointElement, PieController, ArcElement);

const Barchart = ({labels, data, type}) =>
{
	const chartRef = useRef(null);
	const chartInstance = useRef(null);
	useEffect(() => {
		CreateChart();
		return () => {
			if (chartInstance.current)
			{
				chartInstance.current.destroy();
			}
		};
	// eslint-disable-next-line
	}, []);

	const ChartType = (ChartType) =>
	{
		switch (ChartType)
		{
			case 'barchart': ChartType = 'bar'; break;
			case 'linechart': ChartType = 'line'; break;
			case 'piechart': ChartType = 'pie'; break;
			default: break;
		}
		return ChartType;
	}

	const GetChartColors = (data) =>
	{
		let colors = [];
		if (Array.isArray(Object.values(data)))
		{
			for(const value of data)
			{
				if(value["color"])
				{
					colors[colors.length] = value["color"];
				}
			}
		}

		if(colors.length === 0)
		{
			colors = [
				'rgba(255, 99, 132, 0.2)',
				'rgba(54, 162, 235, 0.2)',
				'rgba(255, 206, 86, 0.2)',
				'rgba(75, 192, 192, 0.2)',
				'rgba(153, 102, 255, 0.2)',
				'rgba(255, 159, 64, 0.2)'
			];
		}

		return colors;
	}

	const GetChartValues = (data) =>
	{
		let result = [];
		if (Array.isArray(Object.values(data)))
		{
			for(const value of data)
			{
				if(typeof value == "object" && value["value"])
				{
					result[result.length] = value["value"];
				}
				else
				{
					result[result.length] = value;
				}
			}
		}

		return result;
	}

	const GetChartLabels = (data, labels, type) => {
		if (labels && labels.length > 0)
		{
			return labels;
		}

		if (Array.isArray(data))
		{
			return data.map(value => {
				if (typeof value === "object" && value["label"] !== undefined) 
				{
					return ChartType(type) === "pie"
						? `${value["label"]}(${Math.round(value["value"])}%)`
						: value["label"];
				}
				return '';
			});
		}
		return [];
	};

	const CreateChart = () =>
	{
		let delayed;
		const ctx = chartRef.current.getContext('2d');
		chartInstance.current = new Chart(ctx, {
			type: ChartType(type),
			data: {
				labels: GetChartLabels(data, labels, type),
				datasets: [{
					label: '',
					data: GetChartValues(data),
					backgroundColor: GetChartColors(data),
					borderColor: GetChartColors(data),
					borderRadius: ChartType(type) == "pie" ? 0 : 7,
					borderWidth: 0,
					tension: 0.4,
				}]
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						position: ChartType(type) == "pie" ? 'bottom' : false,
						labels: {
							color: 'white',
							font: {
								family: 'IranYekan',
								size: 10,
							},
							textAlign: 'right',
							padding: 12,
							boxWidth: 10,
							color: 'black'
						},
						rtl: true,
					},
				},
				elements: {
					arc: {
						display:false,
						borderWidth: 0
					}
				},
				animation: {
					onComplete: () => {
						delayed = true;
					},
					delay: (context) => {
						let delay = 0;
						if (context.type === 'data' && context.mode === 'default' && !delayed)
						{
							delay = context.dataIndex * 500 + context.datasetIndex * 100;
						}
						return delay;
					},
				},
				scales: {
					y:{
						beginAtZero: true,
						grid: {
							display:false
						},
						ticks: {
							display: false,
							precision:0
						},
						border: {
							display: false
						},
						title: false,
					},
					x:{
						grid: {
							display:false
						},
						border: {
							display: false
						},
						ticks: {
							display: ChartType(type) !== "pie",
						},
						title: true,
					}
				}
			}
		});
	};
	return (
		<div style={{ position: 'relative', height: '160px', width: '100%' }}>
			<canvas ref={chartRef} />
		</div>
	);
};

export default Barchart;